import { Breadcrumb, Content, Panel, Spacing, Title } from '@/presentation/components'
import { useAtom } from 'jotai/react'
import { useEffect } from 'react'
import _ from 'lodash'
import { defaultTheme } from '@/config/themes/defaultTheme'
import { AccountPersistentStore } from '@/main/store/account'
import { GlobalThemePersistentStore } from '@/main/store/globalTheme'

const Home = () => {
  const user = useAtom(AccountPersistentStore)
  const [theme, setTheme] = useAtom(GlobalThemePersistentStore)
  useEffect(() => {
    if (!user.resale?.theme) return
    if (Object.keys(JSON.parse(user.resale.theme)).length === 0) {
      setTheme(defaultTheme)
      return
    }
    setTheme(_.merge(theme, JSON.parse(user.resale.theme)))
  }, [])

  return (
    <Content>
      <Title>Início</Title>
      <Spacing top='9px' bottom='9px'>
        <Breadcrumb />
      </Spacing>
      <Panel></Panel>
    </Content>
  )
}

export default Home
